// src/components/DayDropdown/DayDropdown.styles.ts
import { styled } from '../stitches.config'
import { FiCalendar } from 'react-icons/fi'

const cellSize = '2.75rem'


export const DayBadge = styled('span', {
  position: 'absolute',
  /* push it lower than 50% */
  top: '62%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: '0.65rem',
  fontWeight: 600,
  // color: '$and12',
  // color: '#aaa',
  pointerEvents: 'none',
  '&:hover': {

    
    color: 'var(--colors-blue11)',
    
  },
})

export const CalendarButton = styled('button', {
  all: 'unset',

  // width: '5rem',
  // height: '5rem',
  padding: '0.5rem', 
  // margin: '0.2rem',
boxSizing: 'border-box',
  position: 'relative',
  display: 'grid',
  placeItems: 'center',
  borderRadius: '0.5rem',
  // backgroundColor: '$appBackground',
  // backgroundColor: '$elementBackground',
  backgroundColor: '$blueBackground',
  // border: '1px solid $elementBorder',
  cursor: 'pointer',
  // transition: 'border-color 0.2s, box-shadow 0.2s',
  transition: 'background-color 0.2s ease',

  '&:hover': {
    // borderColor: '$blue9',
    // boxShadow: '0 0 0 1px $blue9',
    backgroundColor: '$blueHover',
    '& svg': {
      stroke: 'var(--colors-blue11)',
    },
    [`& ${DayBadge}`]: {
      color: 'var(--colors-blue11)',
    },
  },

  variants: {
    open: {
      true: {
        // borderColor: '$blue9',
        // boxShadow: '0 0 0 1px $blue9',
        // backgroundColor: '$elementActive',
        backgroundColor: '$blueHover',

        '& svg': {
          stroke: 'var(--colors-blue11)',
        },

        [`& ${DayBadge}`]: {
          color: 'var(--colors-blue11)',
        },

        '&::after': {
          content: "''",
          position: 'absolute',
          left: '0.2rem',
          right: '0.2rem',
          bottom: 0,
          height: '2px',
          background: 'var(--colors-blue11)',
          // borderRadius: '1px',
        },
      },
    },
  },
})

export const CalendarIcon = styled(FiCalendar, {
  /* you can also bump this slightly if you want */
  width: '2.2rem',
  height: '2.2rem',
  // stroke: '$sand12',
  // fill: '$elementBackground',
  // stroke: '#aaa'
})




export const Container = styled('div', {
  // position: 'relative',
  // display: 'inline-block',
  // // diplay: 'flex',
  // // justifyContent: 'center',
  // width: '8rem',
  // // alignItems: 'center'
  position: 'relative',

  /* make the container only as wide as its contents + center it */
  display: 'block',
  width: 'fit-content',  // shrink‐to‐fit the button inside
  margin: '0 auto',      // horizontally center within its parent
})

export const ControlButton = styled('button', {
  boxSizing: 'border-box',
  width: '100%',
  height: cellSize,
  borderRadius: '0.5rem',
  padding: '0.25rem',
  backgroundColor: '$appBackground',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  border: '1px solid $elementBorder',

  variants: {
    open: {
      true: {
        borderColor: '$blue9',
        boxShadow: '0 0 0 1px $blue9',
      },
    },
  },
})

export const MonthSwitcher = styled('div', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.5rem 0.75rem',
    borderBottom: '1px solid $separator',
    marginBottom: '0.5rem',
  })

  export const MonthButton = styled('button', {
    all: 'unset',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    '& svg': {
      stroke: 'black',     // default grey
    },
  
    '&:hover': {
      '& svg': {
        stroke: '$separator',
      },
    },
  })


  
  export const MonthLabel = styled('span', {
    fontFamily: '$body',    // or whatever your theme token is
    fontSize: '1rem',
    fontWeight: 600,
    color: '$sand12',
  })

export const Menu = styled('div', {
  position: 'absolute',
  top: 'calc(100% + 0.5rem)',
  left: 0,
  backgroundColor: '$appBackground',
  border: '1px solid $elementBorder',
  borderRadius: '0.5rem',
  padding: '0.5rem',
  zIndex: 1000,
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
})

export const Grid = styled('div', {
  display: 'grid',
  gridTemplateColumns: `repeat(7, ${cellSize})`,
  textAlign: 'center',
  gap: '0.25rem',
})

export const HeaderCell = styled('div', {
  width: cellSize,
  height: cellSize,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  color: '$sand12',
})

export const EmptyCell = styled('div', {
  width: cellSize,
  height: cellSize,
})

export const DayCell = styled('button', {
  all: 'unset',
  width: cellSize,
  height: cellSize,
  borderRadius: '50%',
  background: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.875rem',
  color: '$sand12',
  transition: 'background-color 0.2s ease', //

  '&:hover': {
    // backgroundColor: '$gray2',
    backgroundColor: '$elementHover',
  },

  variants: {
    selected: {
      true: {
        // backgroundColor: 'transparent', 
        // color: '$sand12',
        // borderBottom: '2px solid var(--colors-blue11',
        backgroundColor: '$elementActive',
        color: 'white',
      },
    },
  },
})